import { useContext } from "react";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";

import BAAContent from "../baaContent";

import { AuthContext } from "src/context/authContext";
import { FooterContext } from "src/context/footerContext";
import { ToastContext } from "src/context/toastContext";
import { ToastTypes } from "src/types";
import BAAContentFooter from "../baaContentFooter";



const Footer = () => {
  const { isUserAuthorized, isManufacturer } = useContext(AuthContext);
  const { isAccordianShown, changeAccordianVisibility }  = useContext(FooterContext);
  const { showToast } = useContext(ToastContext);
  const navigate = useNavigate();

  const redirectPrivacyPolicy = () => {
    if (!isUserAuthorized) showToast(["You need to sign in or sign up to continue."], ToastTypes.ERROR);
    else navigate("/pages/privacy");
  };

  return (
    <footer className="sticky-bottom footer-policy">
      <div className="container-fluid bg-primary">
        <div className="row justify-content-center text-uppercase">
          <Link to={isUserAuthorized ? (isManufacturer ? `/statistics` : `/cases`) : `/users/sign_in`}
            className="text-white link-underline link-underline-opacity-0 col-auto Hub-Footer-link my-1">
            Home
          </Link>
          <button onClick={redirectPrivacyPolicy}
            role="textbox"
            className="btn btn-link text-white link-underline link-underline-opacity-0 col-auto Hub-Footer-link m-0 p-0 text-uppercase">
            Privacy Policy
          </button>
          <a target="_blank" rel="noreferrer" href="https://www.exogen.com/us/physician/terms-of-use/"
            className="text-white link-underline link-underline-opacity-0 col-auto Hub-Footer-link my-1">
            Legal Disclaimer
          </a>
          <a target="_blank" rel="noreferrer" href="mailto:suggestions@cmcopilot.com"
            className="text-white link-underline link-underline-opacity-0 col-auto Hub-Footer-link my-1">
            Suggestions
          </a>
        </div>
      </div>
      <div className="accordion prescribing-accordion" id="accordionExample">
        <div className="accordion-item">
          <h2 className="accordion-header">
            <button onClick={changeAccordianVisibility} className="accordion-button px-3 py-1 text-uppercase Hub-Footer-link fw-normal footer-accordian fs-5 " type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne">
              Please see important safety information and full prescribing information
              {isAccordianShown ? (
                <i className="bi bi-chevron-down ps-1"></i>
              ) : (
                <i className="bi bi-chevron-up ps-1"></i>
              )}
            </button>
          </h2>
          <div id="collapseOne" className={`accordion-collapse collapse ${isAccordianShown ? 'show' : ''}`} data-bs-parent="#accordionExample">
            <div className="accordion-body p-0">
              <BAAContentFooter />
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
